module.exports = __webpack_public_path__ + "img/login_bg.577e0c92.jpg";